export default __webpack_public_path__ + "static/media/icon-false-circle.0238e761.svg";